import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { guaranteeItems } from '../data/content';
export function Guarantee() {
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-174" data-mp="223y639n82bl6">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-175" data-mp="1x4bpqrc3kf85">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-brand-700 bg-white text-brand-700 shadow-lg" data-id="element-176" data-mp="1x54trkjo8qml">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-177" data-mp="14gforafhw15k" />
          <span className="mt-1 text-[11px] font-extrabold uppercase tracking-wider" data-id="element-178" data-mp="1j4afil9xzvg0">7 days</span>
        </div>
        <p className="mt-6 text-sm font-bold uppercase tracking-wider text-brand-600" data-id="element-179" data-mp="1edby1id7wrb6">7-Day zero-risk guarantee</p>
        <h2 id="guarantee-title" className="mt-2 font-serif text-[34px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-180" data-mp="qnhopas3xkvo">
          Review It. Use It. <em className="text-brand-600" data-id="element-181" data-mp="ln2bcj7tsddp">Decide.</em>
        </h2>
        <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-182" data-mp="oygjg8qup27n">
          <p data-id="element-183" data-mp="txt88z1a8jcv">I don’t want you buying the CBCT Decision Map™ based only on what I say.</p>
          <p className="font-semibold text-ink" data-id="element-184" data-mp="yot4e22kuxeb">
            I want you to open it and see whether the system is useful for your own workflow.
          </p>
          <p data-id="element-185" data-mp="12q50mqfyigvh">For the next 7 days, you can:</p>
        </div>

        <ul className="mx-auto mt-5 grid max-w-xl gap-3 text-left sm:grid-cols-2" data-id="element-186" data-mp="61p6si5tdlck">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-2.5 rounded-xl bg-white px-4 py-3 text-[16px] font-semibold text-ink" data-id="element-187" data-mp="b0a5ue9bxyzf">
              <CheckIcon className="h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-188" data-mp="f3oo7bkqqrg1" />
              {g}
            </li>)}
        </ul>

        <p className="mt-8 text-[17px] leading-relaxed text-ink" data-id="element-189" data-mp="1qfpi14wgp62n">
          If you decide within 7 days that the system isn’t right for you, contact us and we’ll{' '}
          <strong className="text-brand-700" data-id="element-190" data-mp="3ri73pqcrvvpa">refund 100% of your purchase</strong>.
        </p>
        <p className="mt-3 text-[16px] text-muted" data-id="element-191" data-mp="3nhoapsz58jli">
          No complicated process. No unnecessary questions. Just a straightforward 7-day guarantee.
        </p>

        <CtaButton className="mt-10" label="Try the CBCT Decision Map™ risk-free" data-id="element-192" data-mp="59flz8jbhxwr" />
      </div>
    </section>;
}